'use strict';

var base = require('../product/base');

function getCoordinatingItems(dataUrl, swatchName) {
    var url = dataUrl.replace(/%2c/g, ",");
    var detailSection = $('.coordinating-items__details');
    $('.coordinating-items').spinner().start();
    detailSection.empty();
    if ($('.coordinating-items__details').length > 0) {
        $('.coordinating-items__details').css('min-height', '450px');
    }

    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            updateSwatchSelected(swatchName);
            detailSection.append(response.renderedTemplate);
            $('.coordinating-items__details select.variant-picker').selectpicker();
            selectAttribute();
            initCoordinatingSlider();
            $(".js-close-coord-btn").show();
            
            if ($('.coordinating-items__details').length > 0) {
                $('.coordinating-items__details').removeAttr('style');
            }
            $.spinner().stop();
        },
        error: function () {
            if ($('.coordinating-items__details').length > 0) {
                $('.coordinating-items__details').removeAttr('style');
            }
            $.spinner().stop();
        }
    });
}

function updateSwatchSelected(swatchName) {
    // Update selected color name
    var container = $('.coordinating-items');
    container.find('.swatch-name').text(swatchName);

    // Update swatch selected
    var swatches = container.find('.coordinating-swatch');
    $.each(swatches, function () {
        var swatch = $(this);
        var thisSwatchName = swatch.data('name');
        if (thisSwatchName === swatchName) {
            swatch.find('.selection_swatch_color').addClass('selected');
        } else {
            swatch.find('.selection_swatch_color').removeClass('selected');
        }
    });
}

// Selects the attribute button from selected option dropdown
function selectAttribute() {
    $('.coordinating-items #nonswatch-select').on("changed.bs.select", function (e) {
        var selected = $(e.currentTarget).val();
        var itemVariation = $(this).closest('.item__products__variation');
        if (itemVariation.find(".selection-button.selected").data('attr-value') !== selected) {
            if (selected != '') {
                itemVariation.find("[data-attr-value='" + selected + "']").click();
            } else {
                itemVariation.find(".selection-button.selected").click();
            }
        }
    });
}

function highLightSliderItem(itemId, isChecked) {
    var imgCheckmark = $(".coordinating-items .item__nav").find("[data-itemid='" + itemId + "'] .checkmark");
    if (isChecked) {
        imgCheckmark.show();
    } else {
        imgCheckmark.hide();
    }
}

// Start sliders 
function initCoordinatingSlider() {
    var CoordMain = $('.coordinating-items__details .item__products');
    var CoordNav = $('.coordinating-items__details .item__nav');
    CoordMain.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        rows: 0,
        asNavFor: '.coordinating-items__details .item__nav'
    });
    CoordNav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.coordinating-items__details .item__products',
        dots: false,
        centerMode: false,
        rows: 0,
        focusOnSelect: true
    });
}


module.exports = {
    getSwatchProducts: function () {
        $('.coordinating-items__swatches').on('click', '.coordinating-swatch', function () {
            var swatch = $(this);
            var url = swatch.data('url');
            var swatchName = swatch.data('name');

            getCoordinatingItems(url, swatchName);
        })
    },

    updateCheckboxSelection: function () {
        $('.coordinating-items').on('change', '.js-coordinating-checkbox', function () {
            var checkbox = $(this);
            var isChecked = this.checked;
            var itemId = checkbox.attr('id');

            highLightSliderItem(itemId, isChecked);
            base.validateAddToCartButton();
        })
    },

    closeCoordinationItems: function () {
        $('.coordinating-items').on('click', '.js-close-coord-btn', function () {
            $('.coordinating-items__details').empty();
            $(this).hide();
            updateSwatchSelected('');
            base.validateAddToCartButton();
        })
    },

    validateAttrSelection: function () {
        $('.coordinating-items select.variant-picker').on("changed.bs.select", function (e) {
            base.validateAddToCartButton();
        });
    }
};